export default __webpack_public_path__ + "static/media/DSC_7412.cc843e8d.jpg";